/** Avatar colour pairs, picked by `tone` in the data files. */
export const TONES = {
  blue: 'bg-brand-tint text-brand-dark',
  teal: 'bg-[#e6f6f7] text-[#0f8b97]',
  orange: 'bg-[#fff3e6] text-[#b36a1a]',
  violet: 'bg-[#f3ebfd] text-[#7c4dcc]',
  grey: 'bg-surface text-muted',
}
